











$ = require 'jquery'

export default {
  name: 'image-grid'

  props: 
    label: 
      type: String 
      default: null

    # Images per column. Supports 2 and 3
    columns: 
      type: Number
      default: 2

    # Grid items. Should have these keys:
    #   image - loaded asset file 
    #   link - supports absolute, relative, and anchor links
    items: 
      type: Array
      default: -> []

  methods: 
    goto: (selector, e) ->
      if selector.indexOf('#') == 0
        $('html, body').animate({ scrollTop: $(selector).offset().top, easing: 'swing' }, 1000)
      else 
        return true
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/generic/ImageGrid.vue